import { createContext } from "../../../../../../hooks/createContext";

export type GridLayoutContext = {
	rowHeaderSize: number;
	setRowHeaderSize: React.Dispatch<React.SetStateAction<number>>;
	hidePersonaIcons: boolean;
	setHidePersonaIcons: React.Dispatch<React.SetStateAction<boolean>>;
}

export const [useGridLayoutContext, GridLayoutContextProvider] = createContext<GridLayoutContext>()